import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const getPdfs = actionCreator(ActionTypes.GET_PDFS);
export const getPdfsSuccess = actionCreator(ActionTypes.GET_PDFS_SUCCESS);
export const getPdfsFailed = actionCreator(ActionTypes.GET_PDFS_FAILED);
export const countPdfs = actionCreator(ActionTypes.COUNT_PDFS);
export const changePdfPreferences = actionCreator(ActionTypes.CHANGE_PDFS_PREFERENCES);
export const changePdfsOrder = actionCreator(ActionTypes.CHANGE_PDFS_ORDER);
export const uploadPdfs = actionCreator(ActionTypes.UPLOAD_PDFS);
export const uploadPdfsSuccess = actionCreator(ActionTypes.UPLOAD_PDFS_SUCCESS);
export const editPdfs = actionCreator(ActionTypes.EDIT_PDFS);
export const editPdfsSuccess = actionCreator(ActionTypes.EDIT_PDFS_SUCCESS);
export const editPdfsFailed = actionCreator(ActionTypes.EDIT_PDFS_FAILED);
export const clearPdfsForm = actionCreator(ActionTypes.CLEAR_PDFS_FORM);
export const storeTemporaryPdf = actionCreator(ActionTypes.STORE_TEMPORARY_PDF);
export const storeIsPublic = actionCreator(ActionTypes.STORE_IS_PUBLIC);
export const storeIsPublicForAllPdfs = actionCreator(ActionTypes.STORE_IS_PUBLIC_FOR_ALL_PDFS);



// WEBPACK FOOTER //
// ./src/actions/pdfs.js